import { connect } from 'react-redux';
import {
    fetchGetOrgDataById,
    loadingOrg,
    getFetchingErrorOrg,
    clearOrgData, getOrgName, getOrgDataToEditPayments
} from "../../../reducers/organization/organizations";
import {getTranslation} from "../../../reducers/common/localization";
import OrgPaymentsDetails from "./OrgPaymentsDetails";
import {resetSubmitFormData} from "../../../reducers/common/submitForm";
import {Utils} from "../../../utils/utils";

const mapStateToProps = (state, {location}) => {
    return {
        id: Utils.getParamsFromLocationSearch(location.search).id,
        data: getOrgDataToEditPayments(state),
        orgName: getOrgName(state),
        loading: loadingOrg(state),
        fetchingError: getFetchingErrorOrg(state),
        translation: getTranslation(state)
    };
};

const mapDispatchToProps = dispatch => {
    return {
        onMount: (id) => dispatch(fetchGetOrgDataById(id)),
        onUnmount: () => {
            dispatch(clearOrgData());
            dispatch(resetSubmitFormData());
        }
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(OrgPaymentsDetails);



// WEBPACK FOOTER //
// ./src/components/organizationManagement/orgPaymentsDetails/OrgPaymentsDetails.container.js